module.exports = __webpack_public_path__ + "0aa20fb12027a103438536835d97d322.pdf";